<template>
  <div class="content">
    <!-- 上白板step -->

    <!-- body -->
    <div class="body">
      <div class="body-content public_scrill">
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title"> 基本信息</div>
        </div>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm" style="margin-top: 20px;">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="套餐名称:" prop="packName">
              <a-input v-model="searchList.packName" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="套餐类型:" prop="packType">
             
              <a-select
                :allowClear="true"
                v-model="searchList.packType"
                placeholder="请选择套餐类型"
              >
                <a-select-option v-for="item in packTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="所属系列:" prop="belongSeries">
              <a-input v-model="searchList.belongSeries" :allowClear="true" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="套餐有效期限:" prop="expirationDate">
              <a-input type="number" v-model="searchList.expirationDate" :allowClear="true" placeholder="请输入" addon-after="月"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="服务对象类型:" prop="serviceObjType">
             
              <a-select
                :allowClear="true"
                v-model="searchList.serviceObjType"
                placeholder="请选择服务对象类型"
              >
                <a-select-option v-for="item in servTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="人数上限:" prop="upperLimit">
              <a-input v-model="searchList.upperLimit"type="number"   placeholder="请输入">
               
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="套餐状态:" prop="packStatus">
             
              <a-select
                :allowClear="true"
                v-model="searchList.packStatus"
                placeholder="请选择套餐状态"
              >
                <a-select-option v-for="item in commList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  {{item.label}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12"></a-col>
        </a-row>
        <a-row>
          <a-col :span = "24" class="remars">
            <a-form-model-item
              required
              label="配图"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 15 }"
            >
              <upload :downid="searchList.id" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="remark">
          <a-col :span = "24" >
            <a-form-model-item label="服务描述:" prop="packExplain">
          
              <a-textarea v-model="searchList.packExplain" :allowClear="true" placeholder="请输入" />
            </a-form-model-item>
           
          </a-col>
        </a-row>
       
        </a-form-model>
   
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title">服务项目（选择）</div>
        </div>
        <div style="width: 96%;margin: 0 auto;margin-top: 20px;">
          <div v-for="(item,index) in goodsList" :key="index" class="text">
            <div style="display: flex;height: 10px;" class="itemtt"></div>
            <div style="display: flex;">
              <div
                style="width: 50px;height: 30px;line-height: 30px;background-color: rgba(2, 129, 184, 1);text-align: center;color: #ffffff;font-size: 15px;">
                {{ index+1 }}
              </div>
              <div style="margin-left: 50px;height: 30px;line-height: 30px;font-size: 18px;color: rgba(2, 129, 184, 1);">{{item.goodsType | capitalize(item.goodsType)}}</div>
            </div>
            <div style="display: flex;" v-for="(goodss,indexs) in item.goods" :key="indexs">
              <div class="item"></div>
              <div style="margin-left: 72.5px;width: 100%;">
                <div
                  style="height: 55px;line-height: 55px;font-size: 15px;width: 100%;display: flex;justify-content: space-between;border-bottom: 1px solid #e8e8e8;">
                  <div>
                    {{goodss.goodsName}}
                  </div>
                  <div>
                    <div style="display: flex;">
                      <div>
                        ¥{{goodss.goodsDiscountsPrice}}
                      </div>
                      <div style="margin-left: 30px;">
                        <a-button-group>
                          <a-button @click="minus(goodss)" size="small">
                            <a-icon type="minus" />
                          </a-button>
                          <a-input-number v-model="goodss.num"  :disabled="true" :min="0" :max="99" size="small" style="width: 70px;" />
                          <a-button @click="add(goodss)" size="small">
                            <a-icon type="plus" />
                          </a-button>
                        </a-button-group>
                      </div>
                      <div style="margin-left: 30px;">
                        <input v-if="$route.query.id" type="checkbox" style="width: 17px;height: 17px;" :checked="goodss.isSelected" @click="onChanges(goodss)">
                        <div  v-else style="margin-top: 5px !important;"><input  type="checkbox" :checked="goodss.checked" style="width: 17px;height: 17px;" @click="onChange(goodss)">
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: flex-end;margin-top: 20px; margin-right: 30px;height: 32px;
          line-height: 32px;">
          <div style="font-size: 16px;">套餐总价：</div>  
          <a-input :disabled="true" class="" style="width: 200px;"  v-model="SumH"/>
        </div>
      </div>
    </div>
 
    <!-- 下白板按钮 -->
    <div class="blank-border">
      <!-- <a-button class="bottom-button" type="primary"  @click="sum">计算总价</a-button> -->
      <a-button class="bottom-button" type="primary"  @click="submits">提交</a-button>
      <a-button class="bottom-button" type="primary" ghost @click="cancle">取消</a-button>
    </div>
  </div>
</template>

<script>
import {
  pkQueryById,
  getId,
  goodList,
  goodsInfoTypeInfo,
  pkComputePrice,
  pkAddPack,
  pkUpdatePack
} from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from '@common/services/dictionary.service'
let that = this;
export default {
  name: "FtsTrustWebAddInvestment",
  components: {
    upload
  },
  props: {
    Title: {
      type: String,
      default: () => "Title",
    },
  },
  data() {
    //自定义校验规则
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (value > 9999999999) {
            return callback(new Error('数字不能超过10位数'));
        } else {
          if (!Number.isInteger(Number(value))) {
            return callback(new Error('请输入整数'));
          } else if (Number(value) <= 0) {
            return callback(new Error('请输入大于0的数'));
           }
          else{
            return callback();
          }
        }
      } else {
        return callback();
      }
    };
    return {
      isCompile: true, // 是否编辑
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      searchList:{
        packName:'',
        packType:undefined,
        specifications:'1',
        belongSeries:'',
        expirationDate:'',
        serviceObjType:undefined,
        upperLimit:'',
        id:'',
        packExplain:'',
        packStatus:undefined
      },
      SumH:0,
      rules:{
      packName: [
          {
            required: true,
            message: "套餐名称不能为空！",
            trigger: ["blur","change"],
          },
          {
            max: 20,
            message: "套餐名称不可超过20字",
            trigger: ["blur","change"],
          }
        ],
        packType: [
          {
            required: true,
            message: "套餐类型不能为空！",
            trigger: ["blur","change"],
          },
        ],
        belongSeries:[
          {
            required: true,
            message: "所属系列不能为空！",
            trigger: ["blur","change"],
          },
          {
            max: 20,
            message: "所属系列不可超过20字",
            trigger: ["blur","change"],
          }
        ],
        expirationDate:[
          {
            required: true,
            message: "套餐有效期限不能为空！",
            trigger: ["blur","change"],
          },
          {
            trigger: "change",
            validator: checkAge,
          }
        ],
        serviceObjType: [
          {
            required: true,
            message: "服务对象类型不能为空！",
            trigger: ["blur","change"],
          },
        ],
        packStatus:[
        {
            required: true,
            message: "套餐状态不能为空！",
            trigger: ["blur","change"],
          },
        ],
        upperLimit:[
          {
            required: true,
            message: "人数上限不能为空！",
            trigger: ["blur","change"],
          },
          {
            trigger: "change",
            validator: checkAge,
          }
        ],
        id:'',
        packExplain:[
          {
            required: true,
            message: "服务描述不能为空！",
            trigger: ["blur","change"],
          },
          {
            max: 200,
            message: "服务描述不可超过200字",
            trigger: ["blur","change"],
          }
        ],
        },
      id: "",
      uploadAgain: false,
      fileNum: 0,
      value: 1,
      //响应结果
      resData: {},
      url: process.env.VUE_APP_PROXY + "base/file/download-file?id=",
      packTypeList:[],
      servTypeList:[],
      goodsTypeList:[],
      goodsList :[],
      commList:[],
      warnMessage:false
    };
  },
  filters: {
    capitalize: function (value, list) {
      let str = "";
      that.goodsTypeList.forEach((item) => {
        if (item.value == value) {
          str = item.label;
        }
      });
      return str;
    },
  },
  beforeCreate() {
    that = this;
  },
  mounted() {
    //查询
    DictionaryService.getAllNeedDic(["PACK_TYPE","SERV_TYPE",'GOODS_TYPE','COMMONSTATUS']).then((res) => {
        //服务状态
      // this.filterData[0].options = DictionaryService.getOptions("REC_STATUS");
        this.packTypeList = DictionaryService.getOptions("PACK_TYPE");
        this.servTypeList = DictionaryService.getOptions('SERV_TYPE')
        this.goodsTypeList = DictionaryService.getOptions('GOODS_TYPE')
        this.commList = DictionaryService.getOptions('COMMONSTATUS')
        const myremark = document.querySelector('.remark').querySelector('.ant-form-item-label')
        const myrInput = document.querySelector('.remark').querySelector('.ant-form-item-control-wrapper')
        myremark.classList.add('ant-col-2');
        myremark.classList.remove('ant-col-5');
        myrInput.classList.add('ant-col-22');
        myrInput.classList.remove('ant-col-18');
        const myremark1 = document.querySelector('.remark').querySelector('.ant-col-2')
        myremark1.style.width = '12.6% '
        const myrInput1 = document.querySelector('.remark').querySelector('.ant-col-22')
        myrInput1.style.width = '87.4%'

        const myremark2= document.querySelector('.remars').querySelector('.ant-form-item-label')
        const myrInput2 = document.querySelector('.remars').querySelector('.ant-form-item-control-wrapper')
        myremark2.classList.add('ant-col-2');
        myremark2.classList.remove('ant-col-5');
        myrInput2.classList.add('ant-col-22');
        myrInput2.classList.remove('ant-col-18');
        const myremark3 = document.querySelector('.remars').querySelector('.ant-col-2')
        myremark3.style.width = '12.6% '
        const myrInput3= document.querySelector('.remars').querySelector('.ant-col-22')
        myrInput3.style.width = '87.4%'
        
        goodsInfoTypeInfo({}).then(res=>{
        
          this.goodsList = res.content
          this.goodsList.map((item)=>{
            if(item.goods[0]){
              item.goods.map(itemss=>{
                itemss['num'] = 0
                itemss['checked'] = false
                itemss['indeterminate'] = false
              })
          
            }
          })
          getId({}).then((res) => {
            this.searchList.id = res.content.id;
          }, (err) => {
            this.$message.success("获取id失败");
          });
    
      // if(this.$router.query.id){
      //   //查询
        this.queryList();
      // }
        
        })
        
      }); 
  },
  methods: {
    add(itema) {
      let b  =  this.goodsList.map((item)=>{   
        if(item.goods[0]){
          item.goods.map(itemss=>{
            if (itemss.id === itema.id) {
              if (parseInt(itemss['num']) + 1 > 0) {
                itemss['num'] = parseInt(itemss['num']) + 1;
                itemss['checked'] = true;
              } else {
                itemss['num'] = 0;
                itemss['checked'] = false;
              }
            }
          })
        }
        return item
      })
      this.goodsList = []
      this.goodsList = b;
      if (this.$route.query.id) {
        this.onChanges(this.goodsList);
      } else {
        this.onChange(this.goodsList);
      }
    },
    minus(itema){ 
      let b  =  this.goodsList.map((item)=>{
        if(item.goods[0]){
          item.goods.map(itemss=>{
            if (itemss.id === itema.id) {
              if (parseInt(itemss['num']) - 1 > 0) {
                itemss['num'] = parseInt(itemss['num']) - 1;
                itemss['checked'] = true;
              } else {
                itemss['num'] = 0;
                itemss['checked'] = false;
              }
            }
          })
        }
        return item
          })
      this.goodsList = []
      this.goodsList = b;
      if (this.$route.query.id) {
        this.onChanges(this.goodsList);
      } else {
        this.onChange(this.goodsList);
      }
    },
    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      if(val.length == 0){
        this.searchList.id ="";
      } else {
        this.searchList.id = val[0].busId;
        this.uploadAgain = true;//监听是否已上传文件
      }
      this.fileNum = val.length;
    },
    sum() {
      this.SumH = 0;
      if(this.$route.query.id){
          let b = []
          this.goodsList.map((item)=>{
            if(item.goods[0]){
              item.goods.map(itemss=>{
                if(itemss.isSelected){
                  b.push({goodId:itemss.id,goodNum:itemss.num})
              
                }
            
              })
            }
          })
          if (b[0]) {
            pkComputePrice({goods:b}).then(res=>{
            this.SumH = res.content
            })
          } 
      }else{
        let b = []
        this.goodsList.map((item)=>{
          if(item.goods[0]){
            item.goods.map(itemss=>{
              if(itemss.checked){
                b.push({goodId:itemss.id,goodNum:itemss.num})
            
              }
          
            })
          }
        })
        if (b[0]) {
          pkComputePrice({goods:b}).then(res=>{
          this.SumH = res.content
         })
        }
      }
    },
    //查询
    queryList() {
      if(this.$route.query.id){
        pkQueryById({
        id: this.$route.query.id
      })
        .then(res => {
          this.searchList.id = res.content.pictList[0].id;
          this.searchList = res.content 
          this.goodsList = res.content.goodList || [];
          this.SumH = res.content.totalPrice;
        });
      }
     
    },
    onChanges(itema){
      let b = this.goodsList.map((item) => {
        if(item.goods[0]){
          item.goods.map(itemss=>{
            if (itemss.id === itema.id) {
              itemss['isSelected'] = !itemss['isSelected'] 
            }
          })
        }
        return item
      })
      this.goodsList = []
      this.goodsList = b;
      this.sum();
    },
    onChange(itema) {
      let b  =  this.goodsList.map((item)=>{
        if(item.goods[0]){
          item.goods.map(itemss=>{
            if(itemss.id === itema.id){
              itemss['checked'] = !itemss['checked']
              itemss['num'] = 0
            }
          })
        }
        return item
      })
      this.goodsList = []
      this.goodsList = b;
      this.sum();
    }, 
    submits(){
      this.warnMessage = false;
      if (this.$route.query.id) {
        if (this.searchList.id) {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              let b = []
              this.goodsList.map((item) => {
                if(item.goods[0]){
                  item.goods.map(itemss=>{
                    if(itemss.isSelected){
                      b.push({goodsId:itemss.id,packGoodsNum:itemss.num})
                    }
                  })
                }
              })
              this.searchList['goodsList'] =b,
              this.searchList['id'] = this.$route.query.id
              pkUpdatePack(this.searchList).then(res=>{
                this.cancle();
              }, (err) => {
              return this.$message.error("操作失败");
              })
            } 
          })
        }else{
          this.$message.warning("请上传图片");
        }
      }else{
        if (this.searchList.id) {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              let b = []
              this.goodsList.map((item)=>{
              if(item.goods[0]){
                item.goods.map(itemss=>{
                  if(itemss.checked){
                    if(itemss.num == 0){
                      if(this.warnMessage ==  false){
                        this.warnMessage = true;
                        this.$message.warning("选择的商品单项数量必须大于0");
                      }
                      return false;
                    }
                    b.push({goodsId:itemss.id,packGoodsNum:itemss.num})
                
                  }
                })
              }
              })
              if (this.warnMessage =false && b.length == 0) {
                return this.$message.warning("请选择服务项目");
              } else {
                this.searchList['goodsList'] = b
                  pkAddPack(this.searchList).then(res => {
                    this.cancle();
                }, (err) => {
                  return this.$message.error("操作失败");
                }) 
              }
            }
        })
        }else{
          this.$message.warning("请上传图片");
        }
      }
      
    },
    
    // 取消按钮
    cancle() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 90%;

  .nav-border {
    border-bottom: 1px solid #e4e4e4;
    width: 100%;
    height: 50px;
    background: #fff;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;

    .nav-lspan {
      font-size: 16px;
      color: #999999;
      float: left;
      margin: 8px 8px 8px 8px;
    }
  }

  .body {
    display: flex;
    justify-content: space-between;
    height: 90%;
    background: #fff;

    .body-content {
      padding: 15px 20px 15px 20px;
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .content_one {
        height: 50px;
        background-color: #F6F6FA;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  .blank-border {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;

    .bottom-button {
      float: right;
      margin-left: 20px;
    }
  }
}

.addbutton {
  border: 1px #009de5 solid;
  color: #009de5;
  float: right;
  margin: 10px;
  z-index: 100;
}

/deep/ .ant-input-number-input {
  text-align: center;
  width: 100%;
  padding: 0 11px;
  /* text-align: left; */
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  outline: 0;
  transition: all 0.3s linear;
  -moz-appearance: textfield !important;
}
.inpt_box_unit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 32px;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
  background-color: #e9ecef;
}
/deep/ .ant-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  border-collapse: separate;
  transition: all 0.3s;
  width: 30px;
  height: 30px;
}

/deep/ .ant-upload-list {
  display: none;
}
/deep/ .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    top: 50%;
    left: 50%;
    width: 15px;
    height: 15px;
    background-color: #1890ff;
    border: 0;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    content: ' ';
}
.uploadfilelist {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  zoom: 1;

  .fileico {
    margin: 10px;
  }

  .itemname {}

  .itemsta {
    float: right;
    margin-right: 30%;
  }

  .download {
    float: right;
    margin: 5px;
  }

  .del {
    float: right;
    margin: 5px;
  }
}

.uploadfilelist:hover {
  background: #f3fbff;
}

/deep/ .form_title {
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
  margin-left: 15px;
}

.item {
  margin-left: 22.5px;
  width: 5px;
  max-height: 100%;
  background-color: rgba(2, 129, 184, 1);
}

.itemtt{
  margin-left: 22.5px;
  width: 5px;
  max-height: 100%;
  background-color: rgba(2, 129, 184, 1);
}

.text:nth-child(1){
  .itemtt {
    margin-left: 22.5px;
    width: 5px;
    max-height: 0;
    background-color: none !important;
  } 
}

.text:nth-last-child(1){
  .item {
    margin-left: 22.5px;
    width: 5px;
    max-height: 0;
    background-color: none !important;
  } 
}

</style>